const TypesReferenceInfoItem = ({
  typeName = '',
  title = '',
  description = '',
  badge = '',
  tags = [],
  bgColor = '',
  thumbBgColor = '',
  titleColor = '',
  imageUrl = '',
  displayName = '',
  borderColor = '',
  descColor = '',
  sectionTitleCorlor = '',
}) => {
  return (
    <section
      className="w-full bg-white rounded-2xl p-6 shadow-md border border-sky-100 relative overflow-hidden"
      style={{ borderColor: borderColor }}
      id="result"
    >
      <div
        className="absolute top-0 right-0 w-32 h-32 bg-sky-50 rounded-bl-[100px] -z-0 opacity-50"
        style={{ backgroundColor: bgColor }}
      ></div>

      <div className="relative z-10">
        <h2
          className="text-xs font-bold text-[#0096D4] tracking-widest uppercase mb-1"
          style={{ color: sectionTitleCorlor }}
        >
          Total Evaluation
        </h2>
        <h3 className="text-xl font-bold text-slate-800 mb-4">頭皮判定結果</h3>

        <div className="flex items-center gap-5 mb-5">
          <div className="relative">
            <img
              alt="User"
              className="w-20 h-20 rounded-full border-4 border-white shadow-sm object-cover"
              src={imageUrl}
            />
            <div
              className="absolute bottom-0 right-0 w-5 h-5 rounded-full border-2 border-white"
              style={{ backgroundColor: thumbBgColor }}
            />
          </div>

          <div>
            <div className="text-sm text-slate-500 mb-1">総合評価</div>
            <div className="flex items-center gap-2">
              <span className="text-4xl font-bold text-slate-800">{typeName}</span>
              <span className="text-sm font-bold text-slate-600 mt-3">タイプ</span>
              <span
                className="text-[10px] font-bold px-2 py-0.5 rounded border self-center ml-1 text-white"
                style={{ backgroundColor: thumbBgColor, borderColor: thumbBgColor }}
              >
                {badge}
              </span>
            </div>
          </div>
        </div>

        <div
          className="bg-slate-50 rounded-lg p-3 border border-slate-100 mb-4"
          style={{ backgroundColor: bgColor, borderColor: borderColor }}
        >
          <p className="text-sm font-bold text-slate-700 mb-1" style={{ color: titleColor }}>
            {title}
          </p>
          <p className="text-xs text-slate-500 leading-relaxed" style={{ color: descColor }}>
            {description}
          </p>
        </div>

        <div className="flex flex-wrap gap-2">
          {tags.map((tag, index) =>
            index === 0 ? (
              <span
                key={index}
                className="text-[10px] font-bold px-2 py-1 rounded-full shadow-sm text-white"
                style={{ backgroundColor: thumbBgColor }}
              >
                {tag}
              </span>
            ) : (
              <span
                key={index}
                className="text-[10px] text-slate-600 bg-white border border-slate-200 px-2 py-1 rounded-full"
              >
                {tag}
              </span>
            ),
          )}
        </div>
      </div>
    </section>
  );
};

export default TypesReferenceInfoItem;
